import type { SelectChangeEvent } from '@mui/material';
import { MenuItem, Select } from '@mui/material';

export enum CWEvent {
  cw_subscribe = 'cw_subscribe',
  cw_purchase = 'cw_purchase',
  cw_nrc_purchase = 'cw_nrc_purchase',
}

const ITEMS: Record<CWEvent, string> = {
  [CWEvent.cw_subscribe]: 'cw_subscribe',
  [CWEvent.cw_purchase]: 'cw_purchase',
  [CWEvent.cw_nrc_purchase]: 'cw_nrc_purchase',
};

interface Props {
  value: CWEvent;
  onChange: (value: CWEvent) => void;
}

export function CWEventSelect({ value, onChange }: Props) {
  const handleChange = (event: SelectChangeEvent<CWEvent>) => {
    onChange(event.target.value as CWEvent);
  };

  return (
    <Select sx={{ width: 155 }} value={value} onChange={handleChange}>
      {Object.entries(ITEMS).map(([value, label]) => {
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
}
